import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { ClaimType } from '../../models/cases/claimType';

@Component({
  selector: 'app-claim-type-create-edit',
  templateUrl: './claim-type-create-edit.component.html',
  styleUrls: ['./claim-type-create-edit.component.scss']
})
export class ClaimTypeCreateEditComponent implements OnInit {

  public claimTypeData: ClaimType;

  @ViewChild('claimTypesModal') claimTypesModal;
  @Output() submit: EventEmitter<ClaimType> = new EventEmitter<ClaimType>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: FilesApiService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(claimType: ClaimType) {
    this.claimTypeData = Object.assign(new ClaimType(), claimType);
    this.modalRef = this.modalService.open(this.claimTypesModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.claimTypeData.id) {
      this.spinner.show();
      this.api.updateClaimType(this.claimTypeData).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createClaimType(this.claimTypeData).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }


}


